import React from "react"
import "./Switch.css"

class Switch extends React.Component {
  handleChange = () => {
    const { setFieldValue, values } = this.props.form
    const { name } = this.props.field
    const status = !values[name]
    setFieldValue(name, status)
  }
  render() {
    const { on, off, checked, handleChange, disabled, className } = this.props
    return (
      <label className={`switch ${checked ? "on" : "off"} ${className}`}>
        <input
          type="checkbox"
          checked={checked}
          onChange={handleChange || this.handleChange}
          disabled={disabled}
        />
        <span className="slider round" />
        <p>{checked ? on : off}</p>
      </label>
    )
  }
}

export default Switch
